<template>
  <div v-if="notFound" :class="componentClassName">
    <a-page-heading>メール配信管理 </a-page-heading>
    <m-section>
      <m-action-card id="settingsTrialTitle" :title="`メール配信 （${sendList.length}）`">
        <template #action>
          <a-button
            id="addUserAdminBtn"
            :inline="true"
            icon="plus"
            variant="fill"
            color="primary"
            size="small"
            label="メール配信"
            @click="handleButton()"
          />
        </template>

        <m-data-table ref="dataTable" :empty-text="emptyText" :fit="true" :data="sendList">
          <a-data-table-column prop="sendDateTime" :min-width="80" label="送信日時" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_sendDateTime"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('sendDateTime', 'asc')"
                :handle-sort-descending="() => handleSort('sendDateTime', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-sendmail-list__wrap"
            prop="sendCount"
            :min-width="40"
            label="送信件数"
            align="left"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_sendCount"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('sendCount', 'asc')"
                :handle-sort-descending="() => handleSort('sendCount', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="mailSubject" :min-width="180" label="件名" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_mailSubject"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('mailSubject', 'asc')"
                :handle-sort-descending="() => handleSort('mailSubject', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-sendmail-list__wrap"
            prop="mailBody"
            :min-width="180"
            label="本文"
            align="left"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_mailBody"
                class="t-setting-sendmail-list__wrap"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('mailBody', 'asc')"
                :handle-sort-descending="() => handleSort('mailBody', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column type="action" :width="160" align="center" class="a-data-table-column--action">
            <template #default="scope">
              <a-button
                :id="'companyInfoEdit' + scope.index"
                variant="round"
                size="small"
                label="確認"
                color="grey"
                icon="edit"
                icon-color="black"
                :inline="true"
                @click="handleSendMailConf(scope.row)"
              />
            </template>
          </a-data-table-column>
        </m-data-table>
      </m-action-card>
    </m-section>
  </div>

  <!-- Confirm, Error Modal -->
  <teleport to="body">
    <o-modal
      id="settingTrialList_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { POINT } from '@/libs/constants';

export default {
  name: 't-setting-sendmail-list',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sendList: [],
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      notFound: false,
      emptyText: '',
      filterList: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-sendmail-list');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async created() {
    if (this.companyID !== POINT) {
      this.$router.push({ path: '/permission-denied' });
    }

    if (this.authInfo === 'soOperator') {
      this.$router.push({ path: '/permission-denied' });
    }

    await this.handlerFetchSendMailList();
  },
  methods: {
    handlerFetchSendMailList: async function () {
      this.emptyText = 'メール配信情報の取得中です';
      await this.postRequest('/sendmail/getSendMailList')
        .then(e => {
          this.notFound = true;

          for (const tSmail of e.data) {
            tSmail.mailBody = tSmail.mailBody.length > 50 ? tSmail.mailBody.slice(0, 49) + '…' : tSmail.mailBody;
            this.sendList.push(tSmail);
          }

          // 送信日時の降順にソート
          this.sendList.sort((fst, scnd) => {
            if (fst.sendDateTime > scnd.sendDateTime) {
              return -1;
            } else if (fst.sendDateTime < scnd.sendDateTime) {
              return 1;
            } else {
              return 0;
            }
          });
          this.filterList = this.sendList;
        })
        .catch(err => {
          this.showErrorModal(messageContent.requireTry('メール配信情報の取得'));
        });
    },
    handleButton() {
      this.$router.push('/sendmailedit');
    },
    handleSendMailConf(row) {
      this.$router.push({ path: '/sendmailedit', query: { sendID: row.id } });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    getFilterColumnIndex(prop) {
      let columnIndex = -1;
      this.$refs.dataTable.columns.forEach((column, index) => {
        if (column.prop === prop) {
          columnIndex = index;
        }
      });
      return columnIndex;
    },
    handleFilterCancel(prop) {
      const columnIndex = this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
    },
    handleSort(prop, dir) {
      //昇順
      if (dir === 'asc') {
        this.filterList.sort(function (a, b) {
          if (a[prop] < b[prop]) return -1;
          if (a[prop] > b[prop]) return 1;
          return 0;
        });
      }
      //降順
      if (dir === 'desc') {
        this.filterList.sort(function (a, b) {
          if (a[prop] > b[prop]) return -1;
          if (a[prop] < b[prop]) return 1;
          return 0;
        });
      }
      this.handleFilterCancel(prop);
    },
  },
};
</script>
